<main role="main">
  <div class="form">
    <h3>NPC Admin Support</h3>
    <p class="subtitle">Sign in with your Rewiretech Microsoft 365 account.</p>
    <hr />

    @if (errorMessage) {
      <p class="error" role="alert">{{ errorMessage }}</p>
    }

    <button
      mat-flat-button
      type="button"
      color="primary"
      (click)="signInWithMicrosoft()"
      [disabled]="signingIn">
      {{ signingIn ? 'Signing in…' : 'Sign in with Microsoft' }}
    </button>
  </div>
</main>
